<template>
  <b-modal
    title="Export des fiches d'espaces"
    :modal-class="'base-modal'"
    :no-close-on-backdrop="true"
    :no-close-on-esc="true"
    centered
    ref="exportFicheModal"
  >
    <b-container fluid>
      <div>
        <b-form-group>
          <b-form-radio v-model="selected" name="all" :value="0"
            >Toutes les fiches</b-form-radio
          >
          <b-form-radio v-model="selected" name="some-radios" :value="1"
            >La fiche en cours</b-form-radio
          >
        </b-form-group>
      </div>
    </b-container>

    <div slot="modal-footer" class="w-100">
      <div class="footer-action float-right">
        <b-button
          variant="outline-primary"
          size="md"
          class="mx-2"
          @click="close"
        >
          Annuler
        </b-button>
        <b-button v-if="!isExport" variant="primary" size="md" @click="exportFiche">
          Exporter
        </b-button>
        <b-button v-else variant="primary" size="md">
          <b-spinner small type="grow"></b-spinner> En attente
        </b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  props: {
    isExport: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      selected: null
    }
  },
  methods: {
    exportFiche () {
      this.$emit('apply', this.selected)
    },
    close () {
      this.selected = null
      this.$refs['exportFicheModal'].hide()
    },
    open () {
      this.$refs['exportFicheModal'].show()
    }
  }
}
</script>

<style lang="scss" scoped>
.text-edit {
  margin-top: 20px;
  width: 100%;
  p.info {
    font-style: italic;
    color: rgba(0, 0, 0, 0.5);
    font-size: 13px;
    text-align: left;
  }
  h2.sub-title {
    margin-top: 30px;
    font-size: 16px;
    font-weight: 600;
    text-align: left;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ficheEspace/modal/exportFiche.vue